export function nameInitials(name: string) {
	const prepositions = ["DOS", "DAS", "DE", "DA", "DO", "E"];

	const upperCaseName = name.toUpperCase();
	const separateName = upperCaseName.trim().split(" ");
	const filteredName = separateName.filter((word) => !prepositions.includes(word));

	if (filteredName.length > 1) {
		const [firstName, secondName] = filteredName;
		return firstName[0] + secondName[0];
	}

	return upperCaseName[0];
}
